import api, { queryClient } from "../../api";
import ENDPOINTS from "../../api/endpoints";
import UserAuthStore from "../../store/userStore";
import useSessionIdStore from "../../store/useSessionIdStore";
import logger from "../../services/Logger";
import { broadcastInvalidate } from "../../api/broadcastSync";
import QUERYKEYS from "../../api/queryKeys";

export const pinChatAPI = async (uid, value = true, space) => {
  const { user, orgId } = UserAuthStore.getState();

  // Optimistic update: Update cache immediately for instant UI feedback
  const queryKey = space?.space_id 
    ? ['spectra-sparks', space.space_id, orgId, user?.uid, space.owner_id]
    : [QUERYKEYS.CHATS, orgId, user?.uid];
  
  const previousData = queryClient.getQueryData(queryKey);
  
  queryClient.setQueryData(queryKey, (oldData) => {
    if (!oldData) return oldData;
    
    // Handle spectra-sparks nested structure { success, sparks: [...] }
    if (oldData.sparks && Array.isArray(oldData.sparks)) {
      return {
        ...oldData,
        sparks: oldData.sparks.map(chat => 
          chat.uid === uid ? { ...chat, pinned: value } : chat
        )
      };
    }
    
    // Handle regular chats array
    if (Array.isArray(oldData)) {
      return oldData.map(chat => 
        chat.uid === uid ? { ...chat, pinned: value } : chat
      );
    }
    
    return oldData;
  });

  try {
    const ownerId = space?.owner_id ? space?.owner_id : user?.uid;
    const session_id = useSessionIdStore.getState().session_id;

    await api({
      method: "POST",
      url: ENDPOINTS.PIN_SPARK,
      data: {
        chat_id: uid,
        org_id: orgId,
        owner_id: ownerId,
        pin_value: value,
        by: user?.uid,
        session_id,
        space_id: space?.space_id ?? null,
      },
    });
    broadcastInvalidate(queryKey);
  } catch (error) {
    // Rollback on error
    queryClient.setQueryData(queryKey, previousData);
    logger.error('pinChatAPI', 'Error updating pin status', { err: error?.message, chat_id: uid, pinned: value, orgId });
  }
};
